export const PACKAGING_TYPES = {
  NO_PACKAGING: 'NO',
  GIFT_PACKAGING: '500',
};

export const NO_GIFT_PACKAGING = {
  label: 'No gift packaging',
  value: PACKAGING_TYPES.NO_PACKAGING,
};

export const GIFT_PACKAGING_REGULAR = {
  label: 'Gift packaging, $7.50',
  term: 'Free for qualifying InCircle members',
  value: PACKAGING_TYPES.GIFT_PACKAGING,
};

export const FREE_BG_GIFT_PACKAGING = {
  label: 'Gift packaging, $0.00',
  term: 'Free for BG Clients',
  value: PACKAGING_TYPES.GIFT_PACKAGING,
};

export const GIFT_PACKAGING_ELEVATED = {
  label: 'Gift packaging, $7.50',
  term: 'Free for qualifying InCircle members, and for orders containing $700 or more of regular priced merchandise.',
  value: PACKAGING_TYPES.GIFT_PACKAGING,
};

export const GIFT_NOTE_TYPES = {
  NO_GIFT_NOTE: '0',
  FREE_BLANK_NOTE: '1',
  FREE_CUSTOM_MESSAGE: '2',
};

export const NOTE_OPTIONS = [
  {
    label: 'No Gift Note',
    value: GIFT_NOTE_TYPES.NO_GIFT_NOTE,
  },
  {
    label: 'Free Blank Gift Note',
    value: GIFT_NOTE_TYPES.FREE_BLANK_NOTE,
  },
  {
    label: 'Free Custom Message',
    value: GIFT_NOTE_TYPES.FREE_CUSTOM_MESSAGE,
  },
];

export const GIFT_ERRORS = {
  CHARS: 'Row can have a maximum of 26 characters',
  ROWS: 'Maximum rows exceeded',
};

export const GIFT_PACKAGING_PRICE = 7.5;

export const GIFT_RECEIPT_TITLE = 'Send gift receipt';
